import {observable, action} from 'mobx';
import questions from '../assets/data/questions-game-4.json';

class Game4Store {

    @observable teamColors = [
        {
            color: "red",
            name: "Red"
        },
        {
            color: "green",
            name: "Green"
        },
        {
            color: "cyan",
            name: "Blue"
        }];

    @observable numberRounds = 10;
    @observable teamsComposition = [
        {
            teams: 2,
            participants: 1,
        },
        {
            teams: 3,
            participants: 1,
        }
    ];
    @observable numberPlayers = 1;
    @observable answers = [
        {
            label: "Same Level",
            points: 2,
        },
        {
            label: "Lower Level",
            points: 4,
        },
        {
            label: "Higher Level",
            points: 1,
        }
    ];

    @observable levelList = [
        "Basic 1",
        "Basic 2",
        "Basic 3",
        "Intermediate 1",
        "Intermediate 2",
        "Intermediate 3",
        "Advanced 1",
        "Advanced 2"
    ];
    @observable maxLevel = -1;
    @observable levels = [];
    @observable questions = []; // All questions
    @observable players = []; // Players Selected with updated scores
    @observable winner; // Game's Winner
    @observable round = 1;
    @observable isLoading = false;
    @observable selectedAnswer = -1;
    @observable actualPlayer = null;
    @observable nextTurn = 0;
    @observable playerTurn1 = 0;
    @observable playerTurn2 = 0;
    @observable winners = [];
    @observable turn = 0;
    @observable pause = false;
    @observable start = false;
    @observable currentPlayer = -1;

    @action
    resetGame() {
        this.levels = [];
        this.maxLevel = -1;
        this.questions = [];
        this.round = 1;
        this.selectedAnswer = -1;
        this.actualPlayer = null;
        this.alreadyPlayed = [];
        this.winners = [];
        this.players = [];
        this.numberPlayers = 0;
        this.currentPlayer = -1;
    }

    @action
    loadQuestions() {
        this.questions = questions;
        this.levels = this.levelList;
    }

    @action
    setPlayers(numberPlayers) {
        let p = [];
        for (let i = 0; i < numberPlayers; i++) {
            const player = {
                name: this.teamColors[i].name + " team",
                team: this.teamColors[i],
                levels: [],
                score: 0,
            };

            p.push(player);
        }

        // Modify the state only one time
        this.players = p;
        this.numberPlayers = p.length;
    };

    @action
    setSituation(situation) {
        this.situation = situation;
    }

    @action
    changeRound() {
        this.alreadyPlayed = [];
    }

    @action
    setMaxLevel(level) {
        this.maxLevel = level;
    }

    @action
    getPlayerTurn() {
        this.currentPlayer++;

        if (this.currentPlayer === this.players.length)
            this.currentPlayer = 0;

        return this.players[this.currentPlayer];
    }

    @action
    getRandomQuestionByLevel(levels) {
        // Get random level
        //let level = this.levelList[this.maxLevel];

        // Get random question
        const questionsByLevel = this.questions.filter(q => q.level <= this.maxLevel || q.level === 8);

        const questionIndex = Math.floor(Math.random() * questionsByLevel.length);
        const question = questionsByLevel[questionIndex];

        // Remove question to NOT REPEAT
        this.questions = [...this.questions.filter(q => q !== question)];

        return question;
    }
}

export default new Game4Store();


// WEBPACK FOOTER //
// ./src/stores/Game4Store.js